import auth from '@/auth/store';
import dashboard from '@/dashboard/store';
import compliance from '@/compliance/store';
import history from '@/history/store';
import credits from '@/credits/store';
import metrics from '@/metrics/store';
import support from '@/support/store';
import endpoint from '@/endpoint/store';
import template from '@/template/store';
import batch from '@/batch/store';
import invite from '@/invite/store';
import recurrent from '@/recurrent/store';

const stores = {
  auth,
  dashboard,
  compliance,
  template,
  history,
  credits,
  metrics,
  support,
  endpoint,
  batch,
  invite,
  recurrent,
};

export default stores;
